var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCo21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5344_52299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7774 20.2875C18.7774 19.456 19.4526 18.7812 20.2836 18.7812C21.1151 18.7812 21.7899 19.4561 21.7899 20.2875C21.7899 21.7937 18.7773 22.5469 18.7773 23.3H21.7899",
    stroke: "",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5067 20.2828C15.1704 20.2828 16.5192 18.9341 16.5192 17.2703C16.5192 15.6066 15.1704 14.2578 13.5067 14.2578C11.8429 14.2578 10.4941 15.6066 10.4941 17.2703C10.4941 18.9341 11.8429 20.2828 13.5067 20.2828Z",
    stroke: "",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72864 15.1401C7.1638 14.5752 6.39748 14.2578 5.59845 14.2578C3.93594 14.2578 2.58594 15.6078 2.58594 17.2703C2.58594 18.9329 3.93594 20.2828 5.59845 20.2828C6.39753 20.2828 7.1638 19.9654 7.72864 19.4006",
    stroke: "",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.703125 8.23439C0.703125 6.57188 2.05312 5.22188 3.71564 5.22188C4.01311 5.22188 4.30045 5.26519 4.57158 5.34539C4.50455 5.06409 4.46878 4.77038 4.46878 4.46873C4.46873 2.39048 6.15614 0.703125 8.23439 0.703125C10.159 0.703125 11.7485 2.14987 11.9729 4.01461C12.5257 3.37069 13.3451 2.9625 14.2594 2.9625C15.6843 2.9625 16.8795 3.954 17.1924 5.28403C17.8352 4.7738 18.6479 4.46878 19.5313 4.46878C21.6099 4.46878 23.2969 6.15614 23.2969 8.23439C23.2969 9.89803 21.9484 11.2469 20.2844 11.2469H3.71564C2.05195 11.2469 0.703125 9.89803 0.703125 8.23439Z",
    stroke: "",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5344_52299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo21);
export default __webpack_public_path__ + "static/media/co2 1.e556f501c596bb57340505a99eae7086.svg";
export { ForwardRef as ReactComponent };